import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { SSO } from './app/sso/sso.constants';
import { CacheKey } from './app/shared/constants/cachekey.constants';
import { CookieService } from 'ngx-cookie-service';
import 'whatwg-fetch'
import 'url-polyfill'
import { TokenType } from './app/shared/enums/token-type.enum';
import { UserSession } from './app/shared/interface/usersession.interface';
import IdTokenVerifier from 'idtoken-verifier';
import { ApiUrlConstants } from './app/common/constants/api.constants';

declare let apiConfig: any;
if (environment.production) {
  enableProdMode();
}

const cookieService: CookieService = new CookieService(document);
// const IdTokenVerifier = require('idtoken-verifier');
if (process.env.ENV === 'production') {
  // enableProdMode();
}

const errorHandle = function (error: any) {
  if (localStorage.getItem('appadmin.' + error)) {
    let error_count = JSON.parse(localStorage.getItem('appadmin.' + error));
    if (error_count >= 3) {
      localStorage.clear();
      if (document.readyState !== 'loading') {
        document.getElementById('error-sso').style.display = 'block';
        document.getElementById(error).style.display = 'block';
        document.getElementById('loaderContainer').style.display = 'none';

      } else {
        document.addEventListener('DOMContentLoaded', function (event) {
          document.getElementById('error-sso').style.display = 'block';
          document.getElementById(error).style.display = 'block';
          document.getElementById('loaderContainer').style.display = 'none';
        });
      }
    } else {
      localStorage.setItem('appadmin.' + error, JSON.stringify(error_count + 1));
      if (error == 'introspect_error') {
        refreshTokenCheck();
      } else {
        redirect();
      }
    }
  }
  else {
    localStorage.setItem('appadmin.' + error, JSON.stringify(1));
    if (error == 'introspect_error') {
      refreshTokenCheck();
    }
    else {
      redirect();
    }
  }
}


let validateResponse = function (response: any) {
  try {
    let verifier = new IdTokenVerifier();
    let payload = verifier.decode(response).payload;
    if (payload.nonce != cookieService.get(SSO.INTERNAL_NONCE)) {
      // if (payload.nonce != JSON.parse(localStorage.getItem('appadmin.id_nonce'))) {
      redirect();
      return false;
    }
    else {

      if (payload.userinfo == null) {
        localStorage.clear();
        if (document.readyState !== 'loading') {
          document.getElementById('error-sso').style.display = 'block';
          document.getElementById('user_info_error').style.display = 'block';
          document.getElementById('in_error_reason').style.display = 'block';
          document.getElementById('loaderContainer').style.display = 'none';
          document.getElementById('other_error_reason').style.display = 'none';

        }
        else {
          document.addEventListener('DOMContentLoaded', function (event) {
            document.getElementById('error-sso').style.display = 'block';
            document.getElementById('user_info_error').style.display = 'block';
            document.getElementById('in_error_reason').style.display = 'block';
            document.getElementById('loaderContainer').style.display = 'none';
            document.getElementById('other_error_reason').style.display = 'none';
          });
        }
        return false;
      }

      localStorage.removeItem('appadmin.refresh_token_error');
      localStorage.removeItem('appadmin.token_error');
      localStorage.removeItem('appadmin.introspect_error');
      localStorage.setItem('appadmin.UserId', JSON.stringify(payload.userinfo.userId));
      localStorage.setItem('appadmin.UserInfo', JSON.stringify(payload.userinfo));

      if (payload.userinfo && payload.userinfo.memberAllowedCountries) {
        let homeCountry = payload.userinfo.memberAllowedCountries.filter((x: any) => x.homeCountry != null && x.homeCountry === true)[0];
        localStorage.setItem('appreports.homeCountryCode', (homeCountry != null ? homeCountry.isoCodeThree : null));
      }
      localStorage.setItem('appreports.memberAllowedCountries', JSON.stringify(payload.userinfo.memberAllowedCountries));

      let isNewToken: boolean = (localStorage.getItem(SSO.IS_NEW_TOKEN) === "true");
      if (isNewToken && SSO.isRemoveObsoleteCookie()) {
        let accessToken = localStorage.getItem(SSO.INTERNAL_ACCESS_TOKEN);
        let refreshToken = localStorage.getItem(SSO.INTERNAL_REFRESH_TOKEN);
        let uuid = cookieService.get(SSO.INTERNAL_MEMBER_SESSIONID);
        saveAccessToken(constructUserSession(accessToken, refreshToken, uuid));
      }


      return true;
    }
  }
  catch (err) {
    redirect();
    return false;
  }
}
let redirect = function () {
  cookieService.delete(SSO.INTERNAL_NONCE);
  //localStorage.removeItem('appadmin.id_nonce');
  localStorage.removeItem('appadmin.state');
  let state = getnonce();
  let id_nonce = getnonce();
  cookieService.set(SSO.INTERNAL_NONCE, id_nonce, null, apiConfig.cookiePath, apiConfig.cookieDomain);
  // localStorage.setItem('appadmin.id_nonce', JSON.stringify(id_nonce));
  localStorage.setItem('appadmin.state', JSON.stringify(state));
  if (!window.location.pathname.startsWith('/login')) {
    localStorage.setItem('appadmin.Nav_path', JSON.stringify(window.location.pathname + window.location.search));
  }
  else {
    localStorage.removeItem('appadmin.Nav_path');
  }
  window.location.href = apiConfig.ssoApiURL + '/auth?client_id=' + apiConfig.ssoClientID + '&redirect_uri=' + window.location.origin + '/login&scope=openid&response_type=code&state=' + state + '&nonce=' + id_nonce;
}
let loginProcess = function () {
  if(window.location.pathname.includes('/impersonation')){
    const url = new URL(window.location.href);
    const isTitan: string = url.searchParams.get('istitan');
    if(isTitan){
      window.location.href = environment.accountUrl;
    }
  }
  else if (window.location.pathname.includes('/login')) {
    const url = new URL(window.location.href);
    const state: string = url.searchParams.get('state');
    const code: string = url.searchParams.get('code');
    if (state == JSON.parse(localStorage.getItem('appadmin.state')) && code) {

       let configData="/api/Configuration?expiryCode=";  
       let payload = "";
        let headers = new Headers();
      headers.append('Accept', 'application/json');
      headers.append('Content-type', 'application/x-www-form-urlencoded');
     
      let fetchConfigData ={
        headers: headers,
        method: 'GET'

      }
      fetch(ApiUrlConstants.portalUrl + configData + new Date().getTime(), fetchConfigData).then(
        function (response) {
          if (response) {
            response.json().then(function (res: any) {
              payload = 'client_id=' + res.apiConfiguration.ssoClientID + '&client_assertion_type=urn:ietf:params:oauth:client-assertion-type:jwt-bearer&client_assertion=' + res.apiConfiguration.ssoClientAssertion + '&code=' + code + '&grant_type=authorization_code&redirect_uri=' + window.location.origin + '/login';
              let fetchConfig = {
                headers: headers,
                method: 'POST',
                body: payload
              }
              loginProsessAccessToken(res, fetchConfig);
            });

          }
        });
    }
    else {
      redirect();
    }
  }
  else {
    tokenCheck(true);
    // if (!getStoredToken(TokenType.ACCESS_TOKEN)) {
    //   refreshTokenCheck();
    // }
    // else {
    //   validateToken();
    // }
  }
}

let loginProsessAccessToken=function(res,fetchConfig){
  fetch(res.apiConfiguration.ssoApiURL + '/token', fetchConfig).then(
    function (response: any) {
      if (response) {
        response.json().then(function (data: any) {
          if (SSO.isRemoveObsoleteCookie()) {
            const guid = SSO.getnonce();
            cookieService.set(SSO.INTERNAL_MEMBER_SESSIONID, guid, null, res.apiConfiguration.cookiePath, res.apiConfiguration.cookieDomain);
            localStorage.setItem(SSO.LOCAL_MEMBER_SESSION_ID, guid);
            localStorage.setItem(SSO.INTERNAL_ACCESS_TOKEN, data.access_token);
            localStorage.setItem(SSO.INTERNAL_REFRESH_TOKEN, data.refresh_token);
            localStorage.setItem(SSO.IS_NEW_TOKEN, "true");
          } else {
            cookieService.set(SSO.INTERNAL_ACCESS_TOKEN, data.access_token, null, res.apiConfiguration.cookiePath, res.apiConfiguration.cookieDomain);
            cookieService.set(SSO.INTERNAL_REFRESH_TOKEN, data.refresh_token, null, res.apiConfiguration.cookiePath, res.apiConfiguration.cookieDomain);
          }
          if (localStorage.getItem('appadmin.Nav_path')) {
            let Nav_path = JSON.parse(localStorage.getItem('appadmin.Nav_path'));
            localStorage.removeItem('appadmin.Nav_path');
            window.location.href = decodeURIComponent(encodeURIComponent(window.location.origin + Nav_path));
          }
          else {
            window.location.href = window.location.origin;
          }
        });
      }
    })
    .catch(function (err: any) {

      errorHandle('token_error');
    });

}
let tokenCheck = function (validateUuid: boolean) {
  if (validateUuid) {
    checkAndLoadAccessToken();
  } else {
    if (!getStoredToken(TokenType.ACCESS_TOKEN)) {
      refreshTokenCheck();
    }
    else {
      validateToken();
    }
  }
}

let checkAndLoadAccessToken = function () {
  let memberSessionId = cookieService.get(SSO.INTERNAL_MEMBER_SESSIONID);
  let localMemberSessionId = localStorage.getItem(SSO.LOCAL_MEMBER_SESSION_ID);
  let accessToken = getStoredToken(TokenType.ACCESS_TOKEN);
  if (SSO.isRemoveObsoleteCookie()) {
    if (memberSessionId) {
      if (accessToken && (memberSessionId === localMemberSessionId)) {
        validateToken();
      } else {
        getAccessTokendetails(memberSessionId);
      }
    } else {
      removeSessionCookieAndTokens();
      tokenCheck(false);
    }
  } else {
    tokenCheck(false);
  }
}

let removeSessionCookieAndTokens = function () {
  cookieService.delete(SSO.INTERNAL_MEMBER_SESSIONID, apiConfig.cookiePath, apiConfig.cookieDomain);
  localStorage.removeItem(SSO.INTERNAL_ACCESS_TOKEN);
  localStorage.removeItem(SSO.INTERNAL_REFRESH_TOKEN);
  localStorage.removeItem(SSO.LOCAL_MEMBER_SESSION_ID);
  localStorage.removeItem(SSO.IS_NEW_TOKEN);
}

function loadModuleAndHideLoader() {
  platformBrowserDynamic().bootstrapModule(AppModule);
  if (document.readyState !== 'loading') {
    document.getElementById('AdminApp').style.display = 'block';
    document.getElementById('loaderContainer').style.display = 'none';
  }
  else {
    document.addEventListener('DOMContentLoaded', function (event) {
      document.getElementById('AdminApp').style.display = 'block';
      document.getElementById('loaderContainer').style.display = 'none';
    });
  }
}

let validateToken = function () {
  let access_token = getStoredToken(TokenType.ACCESS_TOKEN);
  //  let access_token = JSON.parse(localStorage.getItem('appadmin.access_token'));
  // let payload = 'client_id=' + apiConfig.ssoClientID + '&client_assertion_type=urn:ietf:params:oauth:client-assertion-type:jwt-bearer&client_assertion=' + apiConfig.ssoClientAssertion + '&token_type_hint=access_token&token=' + access_token;
  let configData="/api/Configuration?expiryCode=";  
  let payload = "";

  let headers = new Headers();
  headers.append('Accept', 'application/json');
  headers.append('Content-type', 'application/x-www-form-urlencoded');
  let fetchConfigData ={
    headers: headers,
    method: 'GET'

  }
  fetch(ApiUrlConstants.portalUrl + configData+ new Date().getTime(),fetchConfigData).then(
    function(response:any) {
    if(response){
      response.json().then(function (res: any) {
      payload = 'client_id=' + res.apiConfiguration.ssoClientID + '&client_assertion_type=urn:ietf:params:oauth:client-assertion-type:jwt-bearer&client_assertion=' + res.apiConfiguration.ssoClientAssertion + '&token_type_hint=access_token&token=' + access_token;  
      let fetchConfig = {
        headers: headers,
        method: 'POST',
        body: payload
      }
      validationAccessToken(res,fetchConfig);
    });

   }
   })
    .catch(function (err: any) {
      if (SSO.isRemoveObsoleteCookie()) {
        localStorage.removeItem(SSO.INTERNAL_ACCESS_TOKEN);
      } else {
        cookieService.delete(SSO.INTERNAL_ACCESS_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
      }
      errorHandle('introspect_error');
    });
 
}

let  validationAccessToken=function(res,fetchConfig){
  fetch(res.apiConfiguration.ssoApiURL + '/token/introspect', fetchConfig).then(
    function (response: any) {
      if (response) {
        response.text().then(function (data: any) {
          if (validateResponse(data)) {
            loadModuleAndHideLoader();
          }
        },function (err: any) {
          if (SSO.isRemoveObsoleteCookie()) {
            localStorage.removeItem(SSO.INTERNAL_ACCESS_TOKEN);
          } else {
            cookieService.delete(SSO.INTERNAL_ACCESS_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
          }
          errorHandle('introspect_error');
        })
      }
      else {
        redirect();
      }
    }).catch(function (err: any) {
      if (SSO.isRemoveObsoleteCookie()) {
        localStorage.removeItem(SSO.INTERNAL_ACCESS_TOKEN);
      } else {
        cookieService.delete(SSO.INTERNAL_ACCESS_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
      }
      errorHandle('introspect_error');
    });

}
let refreshTokenCheck = function () {
  let refresh_token = getStoredToken(TokenType.REFRESH_TOKEN);
  if (refresh_token) {
    // let payload = 'client_id=' + apiConfig.ssoClientID + '&client_assertion_type=urn:ietf:params:oauth:client-assertion-type:jwt-bearer&client_assertion=' + apiConfig.ssoClientAssertion + '&refresh_token=' + refresh_token + '&grant_type=refresh_token&redirect_uri=' + window.location.origin + '/login';
    let configData="/api/Configuration?expiryCode=";  
     let payload = "";
   
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
   
    let fetchConfigData ={
      headers: headers,
      method: 'GET'
  
    }
    fetch(ApiUrlConstants.portalUrl + configData + new Date().getTime(), fetchConfigData).then(
      function (response: any) {
        if (response) {
          response.json().then(function (res: any) {
            payload = 'client_id=' + res.apiConfiguration.ssoClientID + '&client_assertion_type=urn:ietf:params:oauth:client-assertion-type:jwt-bearer&client_assertion=' + res.apiConfiguration.ssoClientAssertion + '&refresh_token=' + refresh_token + '&grant_type=refresh_token&redirect_uri=' + window.location.origin + '/login';

            let fetchConfig: any = {
              headers: headers,
              method: 'POST',
              body: payload
            }
            refershAccessToken(res, fetchConfig);
          });

        }
      })
      .catch(function (err: any) {
        if (SSO.isRemoveObsoleteCookie()) {
          localStorage.removeItem(SSO.INTERNAL_REFRESH_TOKEN);
        } else {
          cookieService.delete(SSO.INTERNAL_REFRESH_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
        }
        errorHandle('refresh_token_error');
      });
  }
  else {
    redirect();
  }
}

let refershAccessToken=function(res,fetchConfig){
  fetch(res.apiConfiguration.ssoApiURL + '/token', fetchConfig).then(
    function (response: any) {
      if (response) {
        if (response.status !== 200) {
          if (SSO.isRemoveObsoleteCookie()) {
            localStorage.removeItem(SSO.INTERNAL_ACCESS_TOKEN);
          } else {
            cookieService.delete(SSO.INTERNAL_ACCESS_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
          }
          errorHandle('refresh_token_error');
        }
        response.json().then(function (data: any) {
          if (SSO.isRemoveObsoleteCookie()) {
            const guid = SSO.getnonce();
            cookieService.set(SSO.INTERNAL_MEMBER_SESSIONID, guid, null, res.apiConfiguration.cookiePath, res.apiConfiguration.cookieDomain);
            localStorage.setItem(SSO.LOCAL_MEMBER_SESSION_ID, guid);
            localStorage.setItem(SSO.INTERNAL_ACCESS_TOKEN, data.access_token);
            localStorage.setItem(SSO.INTERNAL_REFRESH_TOKEN, data.refresh_token);
            localStorage.setItem(SSO.IS_NEW_TOKEN, "true");
          } else {
            cookieService.set(SSO.INTERNAL_ACCESS_TOKEN, data.access_token, null, apiConfig.cookiePath, res.apiConfiguration.cookieDomain);
            cookieService.set(SSO.INTERNAL_REFRESH_TOKEN, data.refresh_token, null, res.apiConfiguration.cookiePath, res.apiConfiguration.cookieDomain);
          }
          validateToken();
        });
      }
    }).catch(function (err: any) {
      if (SSO.isRemoveObsoleteCookie()) {
        localStorage.removeItem(SSO.INTERNAL_ACCESS_TOKEN);
      } else {
        cookieService.delete(SSO.INTERNAL_ACCESS_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
      }
      errorHandle('introspect_error');
    });
}
let getnonce = function () {
  let d = new Date().getTime();
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now();
  }
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}

let updateClientAssertion = function () {

  const configUrl = window.location.origin + '/api/Configuration?redirect=' + getnonce();
  const myInit = {
    method: 'GET'
  };
  fetch(configUrl).then(
    function (response: any) {
      if (response) {
        response.json().then(function (data: any) {

          apiConfig.ssoClientAssertion = data.apiConfiguration.ssoClientAssertion;
          apiCheck();
        })
          .catch(function (err: any) {
          });
      }
    })
    .catch(function (err: any) {
    });
}

let checkClientAssertionValidity = function () {

  let clientAssertion = apiConfig.ssoClientAssertion;
  let verifier = new IdTokenVerifier();
  let exp = verifier.decode(clientAssertion).payload.exp;
  let presentEpochTime = Math.round((new Date()).getTime() / 1000);
  if (exp < presentEpochTime) {
    return false;
  } else {
    return true;
  }
}

let apiCheck = function () {
  
  if (apiConfig) {
    if((window.location.pathname.indexOf('/anonymous-retail-subscription/terms-and-condition')>-1)){
      loadModuleAndHideLoader();
    }
    else{
      if (checkClientAssertionValidity()) {

        loginProcess();
      } else {
        updateClientAssertion();
      }
    }
  }
  else {
    setTimeout(function () { apiCheck() }, 2000);
  }
}

/**
 * returns the stored token
 */
let getStoredToken = function (tokenType: TokenType) {
  let token = '';
  let tokenKey = '';
  if (tokenType === TokenType.ACCESS_TOKEN) {
    tokenKey = SSO.INTERNAL_ACCESS_TOKEN;
  } else {
    tokenKey = SSO.INTERNAL_REFRESH_TOKEN;
  }
  if (SSO.isRemoveObsoleteCookie()) {
    let memberSessionId = cookieService.get(SSO.INTERNAL_MEMBER_SESSIONID);
    let localMemberSessionId = localStorage.getItem(SSO.LOCAL_MEMBER_SESSION_ID);
    if (memberSessionId) {
      if (memberSessionId === localMemberSessionId) {
        token = localStorage.getItem(tokenKey);
      }
    }
  } else {
    token = cookieService.get(tokenKey);
  }
  return token;
}

/**
 * Get Access token details based on guid
 * @param guid 
 */
let getAccessTokendetails = function (guid: string) {
  const accountServiceUrl = ApiUrlConstants.enrollmentApigwUrl + 'sessions/' + guid;
  const myHeaders = new Headers();
  const requestInit = {
    method: 'GET',
    headers: myHeaders
  };
  fetch(accountServiceUrl, requestInit)
    .then(
      function (response: any) {
        if (response && response.status !== 404) {
          response.json().then(function (sessionDetails: any) {
            if (sessionDetails && sessionDetails.accessToken !== null && sessionDetails.accessToken !== undefined && sessionDetails.accessToken !== '') {
              // Save the tokens into local storage
              localStorage.setItem(SSO.INTERNAL_ACCESS_TOKEN, sessionDetails.accessToken);
              localStorage.setItem(SSO.INTERNAL_REFRESH_TOKEN, sessionDetails.refreshToken);
              localStorage.setItem(SSO.LOCAL_MEMBER_SESSION_ID, guid);
              localStorage.setItem(SSO.IS_NEW_TOKEN, "false");
            } else {
              removeSessionCookieAndTokens();
            }
            tokenCheck(false);
          });
        } else {
          removeSessionCookieAndTokens();
          tokenCheck(false);
        }
      }).catch(function (err: any) {
        removeSessionCookieAndTokens();
        tokenCheck(false);
      });;
}

let constructUserSession = function (accessToken: string, refreshToken: string, uuid: string): UserSession {
  let userSession: UserSession = {
    accessToken: accessToken,
    refreshToken: refreshToken,
    environment: environment.envName,
    guid: uuid
  };
  return userSession;
}

let saveAccessToken = function (userSession: UserSession) {
  const accountServiceUrl = ApiUrlConstants.enrollmentApigwUrl + 'sessions';
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json")
  const requestInit = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(userSession)
  };
  fetch(accountServiceUrl, requestInit)
    .then(
      function (response: any) {
        if (response && response.status !== 404) {
          response.json().then(function (sessionDetails: any) {
            // Save the tokens into local storage
            localStorage.setItem(SSO.INTERNAL_ACCESS_TOKEN, sessionDetails.accessToken);
            localStorage.setItem(SSO.INTERNAL_REFRESH_TOKEN, sessionDetails.refreshToken);
            localStorage.setItem(SSO.IS_NEW_TOKEN, "false");
          });
        }
      });
}

apiCheck();


// WEBPACK FOOTER //
// ./src/main.ts